import * as React from 'react';



export default class Org extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>

            <defs>
                <polygon id="path-1" points="0 14 13.959 14 13.959 0 0 0"></polygon>
            </defs>
            <g id="icons/organisation" stroke="" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Group-52">
                    <g id="Page-1" transform="translate(1.000000, 1.000000)">
                        <polygon id="Fill-1" fill="#53A9DE" points="12.11 13.525 13.39 13.525 13.39 5.425 12.11 5.425"></polygon>
                        <g id="Group-6">
                            <polyline id="Stroke-2" stroke="" strokeLinecap="round" strokeLinejoin="round" points="6 13.5 0.5 13.5 0.5 0.5 9.5 0.5 9.5 5.34"></polyline>
                            
                            <g id="Clip-5"></g>
                            <polygon id="Stroke-4" stroke="" strokeLinecap="round" strokeLinejoin="round" mask="url(#mask-2)" points="6 13.5 13.459 13.5 13.459 5.5 6 5.5"></polygon>
                        </g>
                        <path d="M2.4746,2.7407 L3.6906,2.7407" id="Stroke-7" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M2.4746,5.1079 L3.6906,5.1079" id="Stroke-8" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M2.4746,7.3042 L3.6906,7.3042" id="Stroke-9" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M7.8672,7.8008 L8.8382,7.8008" id="Stroke-10" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M7.8672,11.0361 L8.8382,11.0361" id="Stroke-11" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M10.6611,7.8008 L11.6331,7.8008" id="Stroke-12" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M10.6611,11.0361 L11.6331,11.0361" id="Stroke-13" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M6.2588,2.7407 L7.4748,2.7407" id="Stroke-14" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
                        <polygon id="Stroke-15" stroke="" strokeLinecap="round" strokeLinejoin="round" points="2.484 13.5 3.979 13.5 3.979 9.5 2.484 9.5"></polygon>
                    </g>
                </g>
            </g>
        </svg>
    )
  }
}
